import { api, ReactQueryOptions, RouterInputs } from '@api'

type inputType = RouterInputs['PartnerDropManager']['getSinglePack']
type queryOptionsType = ReactQueryOptions['PartnerDropManager']['getSinglePack']

export const useGetSinglePack = (input: inputType, options?: queryOptionsType) => {
    return api.PartnerDropManager.getSinglePack.useQuery(input, {
        ...options,
        queryKey: ['PartnerDropManager.getSinglePack', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
}
